export default __webpack_public_path__ + "static/media/bumblebee_icon.4a3e1855.png";